
import axios from "axios";
import { Client } from "client-sdk/src";
import handleError from "../utils/handleError";
import { GetAllCategoriesRequestBuilder } from "client-sdk/src/helpical/categories"

const token = localStorage.getItem("token");

export async function getAllCategories(params: object) {
  try {
    const getCategories = new GetAllCategoriesRequestBuilder()
    .params(params)
      .build();
    const client = new Client(token as string);
    const response = client.execute(
     getCategories,
    );
    return response;
  } catch (error) {
    return handleError(error);
  }
}
export default getAllCategories;
